import script from "./GlobalHeaderLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./GlobalHeaderLanguageSwitcher.vue?vue&type=script&lang=js"

import "./GlobalHeaderLanguageSwitcher.vue?vue&type=style&index=0&id=552d3c08&lang=scss"

const __exports__ = script;

export default __exports__